// extracted by mini-css-extract-plugin
module.exports = {"container":"CallbackScreen_container__XRXAs","content":"CallbackScreen_content__1Afln","logo":"CallbackScreen_logo__KYWE5","ldsRing":"CallbackScreen_ldsRing__2P94a"};